import React from 'react';
import dollarFormat from '../../dollar-format';
import request from 'arcdynamic-request';
import LinkComp from '../LinkComp';
import {PROPERTIES} from '../../consts/tables';
import Dropdown from '../Dropdown/Dropdown';
import { GET_PROPERTIES_FOR_STATSCOLUMNS } from '../Graphql/Queries/propertiesQuery';
import { ApolloConsumer } from '@apollo/client';
import { GetOldResponse } from '../ResponseConversion/GetOldResponse';
import { fetchData } from '../Service/graphQlService';

function percent(value) {
    if (value === undefined || value === null || value === '') return '';
    return Number(value).toFixed(2) + '%';
}

export default class StatsColumn extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: null,
            isBusy: null,
            type: '',
        };
        this.client = null;
        this._setType = this._setType.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    }

    _setType(e) {
        this.setState({type: e.target.value});
    }

    fetch(source, type) {
        this.setState({isBusy: true});
        // const filter = [{
        //     code: 'STATUS',
        //     text: this.props.status,
        //     type: 'exact',
        // }];

        // if (this.props.status === 'Closed') {
        //     filter.push({
        //         code: 'SOLD_PRICE',
        //         text: '',
        //         type: 'notNull',
        //     }, {
        //         code: 'CLOSE_CAP_RATE',
        //         text: '',
        //         type: 'notNull',
        //     });
        // } else {
        //     filter.push({
        //         code: 'LIST_PRICE',
        //         text: '',
        //         type: 'notNull',
        //     }, {
        //         code: 'CAPITALIZATION_RATE',
        //         text: '',
        //         type: 'notNull',
        //     });

        //     if (source === 'STRIVE')
        //         filter.push({
        //             code: 'FEATURED',
        //             text: 'y',
        //             type: 'exact',
        //         });
        // }

        // if (source)
        //     filter.push({
        //         code: 'SOURCE',
        //         text: source,
        //         type: 'exact',
        //     });

        // if (type)
        //     filter.push({
        //         code: 'TYPE',
        //         text: type,
        //         type: 'exact',
        //     });

        const filter = [{
            STATUS: this.props.status,
        }];

        if (this.props.status === 'Closed') {
            filter.push({
                'SOLD_PRICE': '',
            }, {
                'CLOSE_CAP_RATE': '',
            });
        } else {
            filter.push({
                'LIST_PRICE': '',
            }, {
                'CAPITALIZATION_RATE': '',
            });

            if (source === 'STRIVE')
                filter.push({
                    FEATURED: 'y',
                });
        }

        if (source)
            filter.push({
                SOURCE: source,
            });

        if (type)
            filter.push({
                TYPE: type,
            });

        // request(arc.path.api, {
        //     service: 'arcimedes',
        //     action: 'open.datasource.table.Data.getData',
        //     params: ['code', PROPERTIES, {
        //         limit: {
        //             count: 10,
        //             offset: 0,
        //         },
        //         filter,
        //         filterType: 'and',
        //         order: [{
        //             code: this.props.order,
        //             type: 'desc',
        //         }],
        //     }],
        // Remove fields with empty string values
        // const cleanedData = filter.map(obj =>
        //     Object.fromEntries(
        //         Object.entries(obj).filter(([key, value]) => value !== '')
        //     )
        // );
        //we changed in the logic that pavani asked for backend need not send empty string value only send those properties which have values to it
        const cleanedData = filter
            .map(obj =>
                Object.fromEntries(
                    Object.entries(obj).filter(([key, value]) => value !== '')
                )
            )
            .filter(obj => Object.keys(obj).length > 0); // Remove objects that are empty
        const token = localStorage.getItem('authToken');
        var pageParams = {
            page: 1,
            pageSize: 10
        }
        const order = [{
            field: this.props.order,
            order: 'desc',
        }];
        // this.client.query({
        //     query: GET_PROPERTIES_FOR_STATSCOLUMNS, variables: {pageOptions:pageParams, filters: cleanedData,sortOptions:order},fetchPolicy: "no-cache",
        //     context: {
        //         headers: {
        //             authorization: `Bearer ${token}`, // Bearer token added here
        //         },
        //     }
        // })
        fetchData(GET_PROPERTIES_FOR_STATSCOLUMNS,{pageOptions:pageParams, filters: cleanedData,sortOptions:order})
        .then((res) => {
            const transformedRes = [{
                data: {
                    getProperties: [{
                        //here directly accesing properties array for data matching in GetOldResponse purpose
                        ...res.data.getProperties.properties
                    }]
                }
            }];
            const result = GetOldResponse(transformedRes[0],true).responses;
            const transformedresult = result[0].data.map((item) => Object.values(item));
            //if (res && res.success) {
            if(res && res.data.getProperties.properties && res.data.getProperties.properties.length){
                this.setState({
                    items: transformedresult[0],
                    isBusy: null,
                });
            } else {
                this.setState({
                    items: false,
                    isBusy: null,
                });
            }
        });
    }

    handleChangeDropdown(query, queryType, x, key) {
        this.setState({type: query[key]});
    }

    componentDidMount() {
        if(this.client){
            this.fetch(this.props.source, this.state.type);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.source !== this.props.source || prevState.type !== this.state.type)
            this.fetch(this.props.source, this.state.type);
    }

    render() {
        const mapQuery = {};
        {
            const d = new Date();
            d.setUTCFullYear(d.getUTCFullYear() - 1);
            mapQuery.CLOSE_OF_ESCROW_MIN = `${
            d.getUTCMonth() + 1
                }/${d.getUTCDate()}/${d.getUTCFullYear()}`;
        }

        const query = {
            type: this.state.type,
            status: this.props.status,
            source: this.props.source,
            order: this.props.order + '.desc',
        };

        return (
            <ApolloConsumer>
            {client => {
                if (!this.client) {
                    this.client = client;
                }
                return (
            <div className='StatsColumn' data-is-busy={this.state.isBusy}>
                {/* {this.state.items ? ( */}
                    <div className='table-container last'>
                        <div className='table-head'>
                            <div className='stats-title'>Recently {this.props.keyword}</div>
                            <Dropdown className='stats-dropdown'
                                      optionsType='type'
                                      value={this.state.type}
                                      valueKey='type'
                                      handleParentChange={this.handleChangeDropdown}
                                      placeholder='TYPE'
                                      optionKey='code'
                                      optionLabelKey='name'
                            />
                        </div>
                        <table className='stats-table'>
                            <thead/>
                            <tbody>
                            {this.state.items && this.state.items.map((el) => (
                                <tr key={el.ARCIMEDES_ROW_ID}>
                                    <td>{el.TYPE || 'N/A'}</td>
                                    <td className='stats-table-name'>
                                        {this.props.status === 'Active' ? (
                                            <a
                                                href={`https://www.strivere.com/property/${el.ARCIMEDES_ROW_ID}`}
                                                target='_blank'
                                            >
                                                {el.NAME || 'N/A'}
                                            </a>
                                        ) : (
                                            <LinkComp to={{pathname: 'map', query: mapQuery}}>
                                                {el.NAME || 'N/A'}
                                            </LinkComp>
                                        )}
                                    </td>
                                    <td>{el.CITY || 'N/A'}</td>
                                    <td>{el.STATE || 'N/A'}</td>
                                    <td style={{textAlign: 'right'}}>
                                        {this.props.status === 'Active'
                                            ? el.LIST_PRICE
                                                ? dollarFormat(el.LIST_PRICE)
                                                : 'N/A'
                                            : el.SOLD_PRICE
                                                ? dollarFormat(el.SOLD_PRICE)
                                                : 'N/A'}
                                    </td>
                                    <td style={{textAlign: 'right'}}>
                                        {this.props.status === 'Active'
                                            ? el.CAPITALIZATION_RATE
                                                ? percent(el.CAPITALIZATION_RATE)
                                                : 'N/A'
                                            : el.CLOSE_CAP_RATE
                                                ? percent(el.CLOSE_CAP_RATE)
                                                : 'N/A'}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        <LinkComp className='stats-more'
                                  to={{pathname: 'list', query: query}}
                        >
                            See More
                        </LinkComp>
                    </div>
                {/* ) : null} */}
            </div>
            )
        }}

    </ApolloConsumer>
        );
    }
}
